import { Shell } from "../../../components/ops/Shell";
import { useAuth } from "../../../context/AuthContext";
import { dashboardNavItems } from "../dashboardNav";

export function DashboardLayout() {
  const { user, signOut } = useAuth();

  return (
    <Shell
      navItems={dashboardNavItems}
      brandTitle="Formula Soccer"
      brandSubtitle="My Account"
      eyebrow="My Account"
      user={user}
      onSignOut={signOut}
      fallbackTitle="Overview"
      theme="parent"
    />
  );
}
